/**
 * Сведения о выпуске Android-приложения — latest.json рядом с APK
 * (ROADMAP приложения, A1.7). Пишет deploy/publish-apk.sh; читают страница
 * /app веба и само приложение, когда проверяет обновления.
 */

export interface AppRelease {
  versionCode: number;
  versionName: string;
  /** Сборки ниже этой сервер не поддерживает — приложение просит обновиться. */
  minVersionCode: number;
  /** Имя APK рядом с latest.json. */
  file: string;
  sha256: string;
  size: number;
  releasedAt: string;
  notes: string;
}

/** Путь к latest.json от корня сайта (без префикса приложения). */
export const APP_RELEASE_PATH = "/app/android/latest.json";

/** Проверка формы: файл пишет скрипт, но читать его на веру нельзя —
 *  обрывок или ошибка прокси дали бы кнопку «Скачать» без адреса. */
export function parseAppRelease(value: unknown): AppRelease | null {
  if (typeof value !== "object" || value === null) return null;
  const item = value as Record<string, unknown>;
  const numbers = ["versionCode", "minVersionCode", "size"] as const;
  const strings = ["versionName", "file", "sha256", "releasedAt"] as const;
  if (numbers.some((key) => typeof item[key] !== "number")) return null;
  if (strings.some((key) => typeof item[key] !== "string" || item[key] === "")) return null;
  return {
    versionCode: item["versionCode"] as number,
    versionName: item["versionName"] as string,
    minVersionCode: item["minVersionCode"] as number,
    file: item["file"] as string,
    sha256: item["sha256"] as string,
    size: item["size"] as number,
    releasedAt: item["releasedAt"] as string,
    notes: typeof item["notes"] === "string" ? item["notes"] : "",
  };
}
